import React from 'react';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Briefcase, MapPin, Calendar } from 'lucide-react';
import { experiences } from '../mock/mockData';

const Experience = () => {
  return (
    <div className="relative z-10 min-h-screen pt-24 pb-16 px-6">
      <div className="container mx-auto max-w-5xl">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-white mb-4">Professional Experience</h1>
          <p className="text-xl text-gray-300">25+ Years of Executive Leadership Excellence</p>
          <div className="h-1 w-32 bg-gradient-to-r from-blue-600 to-sky-500 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-gradient-to-b from-blue-400 to-sky-400"></div>

          {/* Experience Items */}
          <div className="space-y-12">
            {experiences.map((exp, index) => (
              <div key={exp.id} className={`relative flex items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                {/* Card */}
                <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:pr-8' : 'md:pl-8'}`}>
                  <Card className="p-6 border-blue-900/30 shadow-xl bg-[#060f1e]/80 backdrop-blur hover:shadow-2xl hover:shadow-blue-500/10 transition-all duration-300 hover:scale-105">
                    <div className="flex items-start justify-between mb-3">
                      <Badge className="bg-gradient-to-r from-blue-600 to-sky-500 text-white border-0">
                        {exp.period}
                      </Badge>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">{exp.role}</h3>
                    <div className="flex items-center space-x-4 text-sm text-gray-300 mb-4">
                      <div className="flex items-center space-x-1">
                        <Briefcase className="h-4 w-4 text-sky-400" />
                        <span>{exp.company}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <MapPin className="h-4 w-4 text-blue-400" />
                        <span>{exp.location}</span>
                      </div>
                    </div>
                    <p className="text-gray-200 leading-relaxed mb-4">{exp.description}</p>
                    <div>
                      <h4 className="font-semibold text-white mb-2">Key Highlights:</h4>
                      <ul className="space-y-1">
                        {exp.highlights.map((highlight, i) => (
                          <li key={i} className="text-sm text-gray-300 flex items-start">
                            <span className="text-sky-400 mr-2">•</span>
                            <span>{highlight}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Card>
                </div>

                {/* Center Circle */}
                <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 w-12 h-12 bg-gradient-to-br from-blue-600 to-sky-500 rounded-full items-center justify-center border-4 border-[#0a1628] shadow-lg z-10">
                  <Briefcase className="h-5 w-5 text-white" />
                </div>

                {/* Spacer */}
                <div className="hidden md:block w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;